var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApplicationTab',{attrs:{"application-chiclets":_vm.applicationChiclets,"active-chiclet":_vm.selectedApplication.group},on:{"chicletClick":_vm.setSelectedChiclet}})}
var staticRenderFns = []

export { render, staticRenderFns }